'use strict';

var mobileNav = {
	$this: $('.js-main-nav'),
	active: false,
	setScrollTop: 0,
	sticky: false,
	$btn: $('.btn-mobile-menu'),
	$mobScroll: $('.js-main-nav .mob-scroll'),
	$mobContent: $('.js-main-nav .mob-scroll > .mob-scroll-inner > .mob-scroll-content'),
	openClose: function openClose() {
		if (!mobileNav.active && Modernizr.mq('(max-width:1023px)')) {
			mobileNav.$btn.on('click', function (e) {
				e.preventDefault();
				if (mobileNav.$btn.hasClass('active')) {
					// close:
					mobileNav.$btn.removeClass('active');
					mobileNav.$mobContent.slideUp();
					mobileNav.$mobScroll.removeAttr('style');
					$('.js-header').removeClass('zIndex');
					$('body').removeClass('fixed').removeClass('keep-sticky');
					$('#container').removeAttr('style');
					mobileNav.sticky = false;
				} else {
					// open:
					mobileNav.$btn.addClass('active');
					$('.js-main-nav .main-nav--mobile ul.menu > li.current-menu-ancestor .arrow').click();
					if (mobileNav.$this.hasClass('sticky')) {
						mobileNav.sticky = true;
					}
					$('.js-header').addClass('zIndex');
					if (mobileNav.sticky) {
						$('body').addClass('keep-sticky');
					}
					mobileNav.setScrollTop = $(window).scrollTop();
					$('#container').css({ 'position': 'fixed', 'margin-top': -Math.abs(mobileNav.setScrollTop) });
					$('body').addClass('fixed');
					var windowHeight = $(window).height() - ($('.js-main-nav').hasClass('sticky') ? $('.js-header .header-top').height() : $('.js-header').height());
					mobileNav.$mobScroll.height(windowHeight);
					mobileNav.$mobContent.slideDown();
					$('body').icons.init('.svg-icon');
				}
			});
			mobileNav.active = true;
		}
	},
	openSub: function openSub() {
		mobileNav.$this.on('click', '.arrow', function (e) {
			e.preventDefault();
			var $this = $(this),
			    $submenu = $this.next('.submenu');
			if ($this.hasClass('open')) {
				$this.removeClass('open');
				$submenu.css('height', '0px');
			} else {
				$this.addClass('open');
				var h = $submenu.children('ul').outerHeight(true);
				$submenu.css('height', h);
				//console.log(h);
				$('body').icons.init('.svg-icon');
			}
		});
	},
	init: function init() {
		mobileNav.openClose();
		mobileNav.openSub();
	}
};